export const categories = [
  {
    id: 'general',
    name: '综合爆料门户',
    icon: 'ri-newspaper-line',
    description: '覆盖面最广的综合性爆料大厅，热点事件与突发线索集中流转。',
    count: 42,
  },
  {
    id: 'rights',
    name: '民生消费维权',
    icon: 'ri-scales-3-line',
    description: '聚焦消费纠纷、产品质量与售后推诿，是普通人最常用的维权入口。',
    count: 37,
  },
  {
    id: 'finance',
    name: '财经金融观察',
    icon: 'ri-line-chart-line',
    description: '关注理财陷阱、平台兑付、企业信用与资本市场异常信息。',
    count: 24,
  },
  {
    id: 'tech',
    name: '科技数码',
    icon: 'ri-smartphone-line',
    description: '新机翻车、隐私泄露、算法争议与数码产品实测反馈。',
    count: 29,
  },
  {
    id: 'city',
    name: '城市本地',
    icon: 'ri-map-pin-2-line',
    description: '按城市聚合的本地爆料圈，市政、交通、社区问题就近发声。',
    count: 51,
  },
  {
    id: 'workplace',
    name: '教育职场',
    icon: 'ri-briefcase-4-line',
    description: '招聘套路、职场欠薪、培训退费与校园相关线索的集中地。',
    count: 33,
  },
  {
    id: 'auto',
    name: '汽车出行',
    icon: 'ri-roadster-line',
    description: '车辆质量、售后维保、网约出行与新能源电池问题反馈。',
    count: 21,
  },
  {
    id: 'life',
    name: '生活服务',
    icon: 'ri-service-line',
    description: '房产物业、医疗美容、餐饮外卖与日常服务体验的真实记录。',
    count: 46,
  },
];